import type { SVGProps } from "react";
import { FEATHER_ICONS } from "./feather-icons";

/* Feather icon as inline SVG. Sized by font-size (1em), coloured by the text
   colour, so existing classes like "text-lg text-white" keep working.
   Decorative by default: when an icon carries meaning, give its parent
   control an aria-label. */
interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: string;
}

export default function Icon({ name, className = "", ...rest }: IconProps) {
  const inner = FEATHER_ICONS[name];
  if (!inner && import.meta.env.DEV) console.warn(`Icon "${name}" is not in feather-icons.ts`);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={`icon ${className}`.trim()}
      {...rest}
      dangerouslySetInnerHTML={{ __html: inner ?? "" }}
    />
  );
}
